import { useLocation, Navigate } from 'react-router-dom';

export function AuthRedirect({ mode }) {
    const location = useLocation();
    const originalSearch = location.search;

    const baseUrl = `/auth?mode=${mode}`;

    let newPath = baseUrl;

    if (originalSearch) {
        newPath += originalSearch.replace('?', '&');
    }

    return <Navigate to={newPath} replace />;
}